var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHot = function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14733_15199)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_14733_15199)",
    d: "M10 20.5a8.34 8.34 0 0 1-5.939-2.46 8.34 8.34 0 0 1-2.46-5.938 8.53 8.53 0 0 1 1.815-5.247l.87-1.107a7.58 7.58 0 0 0 1.612-4.662c0-.324.263-.586.586-.586h.06c1.5.01 2.91.603 3.967 1.671a5.63 5.63 0 0 1 1.637 3.983c0 .47.482.78.779.415a1.75 1.75 0 0 0 .393-1.108V4.274a.586.586 0 0 1 .987-.428 14.1 14.1 0 0 1 2.995 4.04c.718 1.464 1.096 2.921 1.096 4.216a8.34 8.34 0 0 1-2.46 5.938A8.34 8.34 0 0 1 10 20.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_14733_15199)",
    d: "M10 20.5a8.34 8.34 0 0 1-5.939-2.46 8.34 8.34 0 0 1-2.46-5.938 8.53 8.53 0 0 1 1.815-5.247l.87-1.107a7.58 7.58 0 0 0 1.612-4.662c0-.324.263-.586.586-.586h.06c1.5.01 2.91.603 3.967 1.671a5.63 5.63 0 0 1 1.637 3.983c0 .47.482.78.779.415a1.75 1.75 0 0 0 .393-1.108V4.274a.586.586 0 0 1 .987-.428 14.1 14.1 0 0 1 2.995 4.04c.718 1.464 1.096 2.921 1.096 4.216a8.34 8.34 0 0 1-2.46 5.938A8.34 8.34 0 0 1 10 20.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_14733_15199)",
    d: "M10 20.5c-2.676 0-4.312-2.937-2.903-5.212l2.405-3.886c.229-.37.767-.37.996 0l2.405 3.886C14.312 17.563 12.675 20.5 10 20.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14733_15199",
    x1: 10,
    x2: 10,
    y1: 0.5,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64BE3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43A816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14733_15199",
    x1: 1.602,
    x2: 20.267,
    y1: 0.5,
    y2: 2.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14733_15199",
    x1: 10,
    x2: 10,
    y1: 20.5,
    y2: 11.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC8D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14733_15199"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h20v20H0z"
  })))));
};
export default SvgHot;